import useSWRImmutable from "swr/immutable"

import { useGetUserData } from "../../../../hooks/useGetUserData"
import { getClientProtected } from "../../clients/clients"
import { LIST_IDENTIFIER_GROUPS } from "../../urls/private"

export interface IListIdentifierGroups {
    groups: string[]
    isLoading: boolean
    isError: boolean
}

const isStringArray = (arg: unknown): arg is string[] => {
    const argChecked = arg as []
    return Array.isArray(argChecked)
}

export const useIdentifierGroups = (): IListIdentifierGroups => {
    const { isEnaSysAdmin } = useGetUserData()
    const {
        data: groups,
        error,
        isLoading,
    } = useSWRImmutable(
        isEnaSysAdmin ? LIST_IDENTIFIER_GROUPS() : null,
        async (url: string): Promise<string[]> => {
            try {
                const res = await getClientProtected(url)
                if (isStringArray(res)) {
                    return res
                }
                throw Error()
            } catch {
                throw Error()
            }
        }
    )
    return {
        groups: groups || [],
        isLoading,
        isError: error,
    }
}
